export type PublicUseCaseSlug =
  | 'automated-test-reporting'
  | 'flaky-test-tracking'
  | 'test-suite-health'
  | 'manual-test-reporting';

export type PublicUseCasePageContent = {
  slug: PublicUseCaseSlug;
  path: string;
  title: string;
  navLabel: string;
  cardCopy: string;
  heroTitle: string;
  description: string;
  imageAlt: string;
  previewPath: string;
};

export const publicUseCasePages = [
  {
    slug: 'automated-test-reporting',
    path: '/use-cases/automated-test-reporting',
    title: 'Automated Test Reporting Software | FlowQA',
    navLabel: 'Automated Test Reporting',
    cardCopy:
      'Keep CI test results after the build ends, with searchable runs, counts and history in one place.',
    heroTitle: 'Automated test reports that outlive the build.',
    description:
      'Store JUnit XML, Playwright and other automated test results in FlowQA for durable run history, searchable failures and clearer release reporting.',
    imageAlt: 'FlowQA automated test reporting run summary and test result history',
    previewPath: '/preview/suites',
  },
  {
    slug: 'flaky-test-tracking',
    path: '/use-cases/flaky-test-tracking',
    title: 'Flaky Test Tracking and Test History | FlowQA',
    navLabel: 'Flaky Test Tracking',
    cardCopy:
      'See intermittent pass and fail patterns across runs, with a Flake Score that points to unstable tests.',
    heroTitle: 'Find flaky tests before they become background noise.',
    description:
      'Track intermittent test failures across runs with FlowQA history, Flake Score and test-level evidence for faster investigation.',
    imageAlt: 'FlowQA flaky test history showing intermittent pass and fail results',
    previewPath: '/preview/tests',
  },
  {
    slug: 'test-suite-health',
    path: '/use-cases/test-suite-health',
    title: 'Test Suite Health Metrics and Trends | FlowQA',
    navLabel: 'Test Suite Health',
    cardCopy:
      'Follow pass rate, run frequency, average duration and Flake Score without rebuilding a dashboard.',
    heroTitle: 'Know whether your test suite is getting healthier.',
    description:
      'Monitor test suite health with pass rate, execution frequency, average duration and Flake Score trends in FlowQA.',
    imageAlt: 'FlowQA test suite health metrics for pass rate frequency duration and flake score',
    previewPath: '/preview/trends',
  },
  {
    slug: 'manual-test-reporting',
    path: '/use-cases/manual-test-reporting',
    title: 'Manual Test Reporting from CSV and XLSX | FlowQA',
    navLabel: 'Manual Test Reporting',
    cardCopy:
      'Import CSV or XLSX results, map your columns once and keep manual runs beside automated results.',
    heroTitle: 'Turn manual test files into reportable history.',
    description:
      'Import manual test results from CSV or XLSX into FlowQA, map columns and keep every run searchable alongside automated testing.',
    imageAlt: 'FlowQA manual test result upload and spreadsheet column mapping',
    previewPath: '/preview/suites',
  },
] as const satisfies readonly PublicUseCasePageContent[];
